var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMicrosoftLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H13.1791C13.1791 4.44 13.1791 8.88 13.1791 13.32H0V0Z",
    fill: "#F25022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5247 0H27.7038C27.7038 4.44 27.7038 8.88 27.7038 13.32H14.5255C14.5255 8.88 14.5255 4.44 14.5255 0H14.5247Z",
    fill: "#80BA01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.6792C4.39304 14.6792 8.78609 14.6792 13.1791 14.6792C13.1791 19.1192 13.1791 23.5589 13.1791 27.9984H0V14.6792Z",
    fill: "#02A4EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5255 14.6807C18.918 14.6807 23.3107 14.6807 27.7038 14.6807V28.0007H14.5247C14.5247 23.5607 14.5247 19.1209 14.5247 14.6815L14.5255 14.6807Z",
    fill: "#FFB902"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicrosoftLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MicrosoftLogo.82257ab5.svg";
export { ForwardRef as ReactComponent };